import _extends from '@babel/runtime/helpers/extends';
import React__default from 'react';
import { D as DropdownButtonContent, a as StyledDropdownButton } from './Dropdown.styles-9_d4LEFq.js';
import { w as withTaktFallbackId } from '../TaktIdContext/TaktIdContext-C6vdL-6Z.js';
import { c as createStormTaktId } from '../TaktIdContext/TaktIdContext.utils-B0CzqlN8.js';
import { I as Icon } from '../Icon/Icon-BVCquTfq.js';
import { h as angleDown } from '../LocalModules/storm-ui-icons/dist/esm/localIcons-B_pWoZ1u-Bxh9jPb6.js';

const StyledButton = withTaktFallbackId(StyledDropdownButton);
const DropdownButton = ({
  buttonText,
  disabled = false,
  small = false,
  ...restProps
}) => /*#__PURE__*/React__default.createElement(StyledButton, _extends({}, restProps, {
  taktFallbackId: createStormTaktId('trigger-button'),
  disabled: disabled,
  small: small
}), /*#__PURE__*/React__default.createElement(DropdownButtonContent, null, buttonText), /*#__PURE__*/React__default.createElement(Icon, {
  type: angleDown
}));

export { DropdownButton as D };
//# sourceMappingURL=DropdownButton-DaLHI3NX.js.map
